import {ListItem, ListItemText, Radio} from '@mui/material';
import {string} from 'prop-types';
import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setPreference} from '@src/actions/settings.js';
import {SETTINGS_KEY} from '@src/constants';
import {get as getStored, set as setStored} from '@src/utils/store.js';

const Setting = ({group, value, description, example}) => {
  const dispatch = useDispatch();

  const settings = useSelector(state => state.settings);

  const isActive = settings[group] === value;

  const updateLocalStore = useCallback(() => {
    const state = {[group]: value};
    const localStore = getStored(SETTINGS_KEY);

    setStored(SETTINGS_KEY, {...localStore, ...state});
  }, [group, value]);

  const activate = useCallback(() => {
    dispatch(
      setPreference({
        key: group,
        value: value,
      }),
    );
  }, [dispatch, group, value]);

  useEffect(() => {
    if (isActive) {
      updateLocalStore();
    }
  }, [isActive, updateLocalStore]);

  return (
    <ListItem
      sx={{
        paddingBlock: 0,
        paddingInline: 1,
      }}
    >
      <Radio
        color="primary"
        name={group}
        value={value}
        checked={isActive}
        onChange={activate}
      />
      <ListItemText
        primary={description}
        secondary={example}
        slotProps={{
          primary: {
            variant: 'body1',
          },
          secondary: {
            variant: 'caption',
            component: 'p',
            color: 'text.primary',
          },
        }}
      />
    </ListItem>
  );
};

Setting.propTypes = {
  description: string.isRequired,
  example: string,
  value: string.isRequired,
  group: string.isRequired,
};

export default Setting;
